"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SectionItem = require("./SectionItem");
Object.keys(_SectionItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SectionItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SectionItem[key];
    }
  });
});
